export default "__VITE_ASSET__rdagGGQO__"